import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const dreyevConfig: TSPConfig = {
  key: 'dreyev',
  name: 'Dreyev',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please enter the email address and password you use to log in to your Dreyev account.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Email', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default dreyevConfig;
